import { render, staticRenderFns } from "./OrderSaleUnit.vue?vue&type=template&id=4470e6a0"
import script from "./OrderSaleUnit.vue?vue&type=script&lang=js"
export * from "./OrderSaleUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports